import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import guestOnly from '@/middleware/guestOnly';
import SeasonStart from '../views/account/season-start.vue'
import SeasonSaved from '../views/account/season-saved.vue'

import Main from '../views/index.vue'
import Success from '../views/success.vue'
import Password from '../views/password.vue'
import Auth from '../views/auth.vue'
import Login from '../views/login.vue'
import Statistic from '../views/account/statistic.vue'
import Community from '../views/account/community.vue'
import Rating from '../views/account/rating.vue'
import Profile from '../views/profile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    beforeEnter: guestOnly,
    meta: {
      title: 'Главная'
    }
  },
  {
    path: '/success',
    component: Success,
    meta: {
      title: 'Регистрация успешна'
    }
  },
  {
    path: '/auth',
    component: Auth,
    beforeEnter: guestOnly,
    meta: {
      title: 'Авторизация'
    }
  },
  {
    path: '/password',
    component: Password,
    meta: {
      title: 'Как сменить пароль?',
      requiresAuth: true,
    }
  },
  {
    path: '/login',
    component: Login,
    beforeEnter: guestOnly,
    meta: {
      title: 'Авторизация'
    }
  },
  {
    path: '/account/statistic',
    component: Statistic,
    meta: {
      title: 'Статистика клуба',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
  {
    path: '/account/rating',
    component: Rating,
    meta: {
      title: 'Рейтинги',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
  {
    path: '/account/community',
    component: Community,
    meta: {
      title: 'Тренировки участников',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
  {
    path: '/profile',
    component: Profile,
    meta: {
      title: 'Личный кабинет',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
  {
    path: '/season/start',
    component: SeasonStart,
    meta: {
      title: 'Сезон — старт',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
  {
    path: '/season/saved',
    component: SeasonSaved,
    meta: {
      title: 'Сезон — кластер сохранён',
      requiresAuth: true,
      seasonGoal: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some(r => r.meta.requiresAuth)

  if (requiresAuth && !token) {
    next('/login')
    return
  }

  if (token) {
    try {
      if (!store.getters['auth/user']) {
        await store.dispatch('auth/getUser')
      }
    } catch (error) {
      localStorage.removeItem('token')
      next('/login')
      return
    }
  }
  next()
})


export default router
